<template>
  <div class="deal-form-wrapper">
    <div v-if="deal.supplierId || dealSavings" class="deal-form-tabs">
      <div v-if="deal.supplierId" class="deal-form-tab">
        <b-img-lazy v-if="supplierLogo" :src="supplierLogo" />
        <span class="p-1 small" v-else>{{ deal.supplierName }}</span>
      </div>
      <div v-if="dealSavings" class="deal-form-tab savings-tab">
        <b-badge variant="primary"> Savings: {{ $currencySymbol }}{{ dealSavings }} </b-badge>
      </div>
    </div>

    <div :class="dealFormClass" tabindex="0">
      <deal-form-toolbar
        :deal="deal"
        :supply="supply"
        :show-fields.sync="showFields"
        :draft-id="deal.draftId"
        :supplyContractIds="supplyContractIds"
        @loadSupplyContractIds="loadSupplyContractIds"
        @change="assignDraftId"
      />
      <b-form @change="assignDraftId" @edit="assignDraftId">
        <div class="inline-inputs">
          <b-form-group label="Supplier">
            <b-form-select
              :value="deal.supplierId"
              :options="supplierOptions"
              @change="assignSupplier"
            />
          </b-form-group>

          <b-form-group label="Duty of Care Charge">
            <b-form-input v-model="deal.careDutyCharge" type="number" min="0" />
          </b-form-group>

          <b-form-group label="Annual Cost">
            <annual-cost-input :deal="deal" :supply="supply" @change="set('annualCost', $event)" />
          </b-form-group>

          <b-form-group v-if="CURRENT && showFields.projected" label="Proj Annual Cost">
            <b-form-input v-model="deal.projectedAnnualCost" type="number" min="0" />
          </b-form-group>

          <b-form-group v-if="CURRENT && showFields.estimated" label="Estimated Annual Cost">
            <b-form-input v-model="deal.estimatedAnnualCost" type="number" min="0" />
          </b-form-group>

          <b-form-group label="Description">
            <b-form-textarea v-model="deal.description" />
          </b-form-group>

          <b-form-group v-if="CURRENT || FUTURE" label="Contract Start">
            <date-input v-model="deal.contractStartDate" />
          </b-form-group>

          <b-form-group v-if="FUTURE" label="Contract Term">
            <contract-term-input v-model="deal.contractTerm" />
          </b-form-group>

          <b-form-group v-if="CURRENT || LEGACY" label="Contract End">
            <date-input v-model="deal.contractExpiry" />
          </b-form-group>

          <!-- Commission fields -->
          <b-form-group v-if="FUTURE" label="Total Commission">
            <total-commission-input
              :deal="deal"
              :supply="supply"
              @change="set('consumptionCommission', $event)"
            />
          </b-form-group>

          <div class="break"></div>
          <bins-input :bins="deal.bins" @change="set('bins', $event)" />

          <!-- For smooth tabbing -->
          <a @focus="focusOnSaveBtn($el)" href />
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { dealFormMixin } from "../mixins/dealFormMixin";
import TotalCommissionInput from "./parts/inputs/calculated/TotalCommissionInput";
import AnnualCostInput from "./parts/inputs/calculated/AnnualCostInput";
import BinsInput from "./parts/inputs/waste/BinsInput";

export default {
  name: "WasteDealForm",
  mixins: [dealFormMixin],
  components: { TotalCommissionInput, AnnualCostInput, BinsInput }
};
</script>
